(function($) {
    'use strict';

    $('.filter-dropdown').on('mouseup', function (e) {
        if (e && e.currentTarget) {
            var target = $(e.currentTarget);
            if (target.parents('.keep-open').length) { // ES: Only added <= breakpoint sm
                target.parent().find('.filter-dropdown').removeClass('last-clicked');
                target.addClass('last-clicked');
            }
        }
    });

    // don't close dropdown when selecting filter options
    $('.filter-dropdown').on('hide.bs.dropdown', function (e) {
        var clickTarget;

        if( e.clickEvent && e.clickEvent.target ) {
            clickTarget = $(e.clickEvent.target);
        } else if (e && e.target) {
            clickTarget = $(e.target);
        }
        if (clickTarget) {
            if( clickTarget.hasClass( "keep-open" ) || clickTarget.parents( ".keep-open" ).length ){
                return clickTarget.hasClass('last-clicked');
                // return false; // returning false should stop the dropdown from hiding.
            } else {
                return true;
            }
        } else {
            return true;
        }
    });

})(jQuery);